<template>
  <div>
    <h1 class="modal-h1 mb-3">
      <button type="button"
              class="btn btn-back"
              @click="$emit('cancel')"
      />
      Create Truck
    </h1>
    <form autocomplete="no"
          @submit.prevent="create"
          @keydown="clearError($event)"
    >
      <div class="l-bg-white">
        <div class="row mb-3">
          <div class="col-6">
            <div class="select-wrap">
              <label>Truck name</label>
              <input v-model="truck.name"
                     type="text"
                     placeholder="Enter Name"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="name" />
          </div>
          <div class="col-6">
            <div class="select-wrap">
              <label>Licence plate</label>
              <input v-model="truck.licence_plate"
                     type="text"
                     placeholder="Enter Licence Plate"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="licence_plate" />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-6">
            <div class="select-wrap">
              <label>Size</label>
              <simple-select v-model="truck.truck_size_id"
                             :options="truck_sizes"
                             placeholder="Select Size"
              />
            </div>
            <error-field :errors="errors" field="truck_size_id" />
          </div>
          <div class="col-6">
            <div class="select-wrap">
              <label>Seats</label>
              <input v-model="truck.number_of_seats"
                     type="text"
                     placeholder="Enter No of Seats"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="number_of_seats" />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-6" v-if="carriers && carriers.length">
            <div class="select-wrap">
              <label>Carrier</label>
              <simple-select v-model="truck.carrier_id"
                             :options="carriers"
                             placeholder="Select Carrier"
              />
            </div>
            <error-field :errors="errors" field="carrier" />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-6">
            <div class="select-wrap">
              <label>Make</label>
              <input v-model="truck.make"
                     type="text"
                     placeholder="Enter Make"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="make" />
          </div>
          <div class="col-6">
            <div class="select-wrap">
              <label>Model</label>
              <input v-model="truck.model"
                     type="text"
                     placeholder="Enter Model"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="model" />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-6">
            <div class="select-wrap">
              <label>Year</label>
              <input v-model="truck.year"
                     type="text"
                     placeholder="Enter Year"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="year" />
          </div>
          <div class="col-6">
            <div class="select-wrap">
              <label>Zip</label>
              <input v-model="truck.zip"
                     type="text"
                     placeholder="Enter Zip Code"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="zip" />
          </div>
        </div>

        <div class="row mb-3">
          <div class="col">
            <button class="btn btn-primary float-right ld-ext-right"
                    :class="loadingButton ? 'running' : ''"
                    :disabled="buttonDisabled"
            >
              Create
              <div class="ld ld-ball ld-flip" />
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import { mapState } from 'vuex';
import Errors from '../../classes/Errors';
import ErrorField from '../ErrorField';

export default {
  components: {
    ErrorField,
  },
  data: () => ({
    truck_sizes: [],
    truck: {
      carrier_id: null,
      image: '',
      licence_plate: '',
      make: '',
      model: '',
      name: '',
      number_of_seats: null,
      truck_size_id: 0,
      year: '',
      zip: '',
    },
    loadingButton: false,
    buttonDisabled: false,
    errors: new Errors(),
  }),
  computed: {
    ...mapState({
      carriers: state => state.carriers.carriers.data,
    }),
  },
  mounted() {
    axios
      .get(`/values/truck-sizes`)
      .then(res => {
        this.truck_sizes = res.data.data;
      })
      .catch(err => this.errors.record(err.response.data.error));
  },
  methods: {
    create() {
      this.loadingButton = true;
      this.buttonDisabled = true;
      const truck = Object.assign({}, this.truck);
      axios
        .post(`trucks`, { ...truck })
        .then(() => {
          toastr.success('Successfully created truck');
          this.$emit('update');
          this.$emit('cancel');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/trucks/TrucksCreate.vue